import React, { useState, useEffect } from "react";
import styled from "styled-components";
import { Icon } from 'semantic-ui-react';
import CloseIcon from "../../../../Assets/icons/Close.jpg";
import UploadIcon from "../../../../Assets/icons/upload.png";

export const DragAndDropContainer = styled.div`
  cursor: pointer;
  position: relative;
  padding: 8px;
  border: 2px dashed lightgray;
  text-align: center;
  width: 100%;
  margin: 0 0 1px 0;
  background-color: rgb(255, 255, 255);

  label {
    cursor: pointer;
  }

  ${(props) => !(props.children[5].props.children[0].props.disabled) && `&:hover{
    background-color: #e6efff;
    border: 2px dashed #206fcf;
  }`
  }
`;

const DragAndDropFileUpload = ({
    onUpload = () => {},
    onDelete = () => {},
    acceptFileTypes = [],
    maxFileSize = 30000000,
    hintText,
    uploadedFilesRows,
    ClearAttachmentError,
    numberofFiles = 5,
    isDisabled = false
}) => {
    const [errorMessage, setErrorMessage] = useState("");

    useEffect(() => {
        ClearAttachmentError.current = ClearAttachmentErrors;
    }, [])

    const dragenter = (e) => {
        e.stopPropagation();
        e.preventDefault();
    };
    
    const dragover = (e) => {
        e.stopPropagation();
        e.preventDefault();
    };
    
    const drop = (e) => {
        e.stopPropagation();
        e.preventDefault();
        handleFiles && handleFiles(e);
    };

    const handleFiles = (e) => {
        setErrorMessage("");
        const filesList = Array.from(
          (e.dataTransfer && e.dataTransfer.files) || (e.target && e.target.files)
        );
        const errorMessage = handleFileBeforeUpload(filesList);
        if (errorMessage) {
          setErrorMessage(errorMessage);
        } else {
          onUpload && onUpload(filesList);
        }
        e.target.value = null;
    };

    //Checks file size and accepted types
    const handleFileBeforeUpload = (files) => {
        let hasError = "";
        if (files) {
            for (let i = 0; i < files.length; i++) {
                if (isAllowedFileType(files[i].name)) {
                    if (!hasAllowedSize(files[i])) {
                        hasError = "File(s) is too large. Please choose a smaller file.";
                        break;
                    }
                } else {
                    hasError = "This file(s) will not be uploaded. File type is not allowed.";
                    break;
                }
            }
            var FileCount = Number(uploadedFilesRows.length + files.length);
            if(FileCount > numberofFiles){
                hasError = "This file(s) will not be uploaded. Reached Maximum Number of Files"
            }

        }
        return hasError;
    };

    const isAllowedFileType = (fileName) => {
        var IsNonExecutableFile = true;
        var DefaultRestrictTypes = [".exe",".zip",".zipx",".rar",".bat",".msi"];
        DefaultRestrictTypes.forEach(ele => {
            if(fileName.toLowerCase().indexOf(ele) >= 0){
                IsNonExecutableFile = false;
            }
        });
        
        if(IsNonExecutableFile){
            return acceptFileTypes
          ? acceptFileTypes.some(
              (extension) => extension === fileName.split(".").pop().toLowerCase()
            )
          : true;
        }else{
            return false;
        }
        
    };

    const hasAllowedSize = (file) => {
        return file.size < maxFileSize && file.size >= 1;
    };

    const ClearAttachmentErrors = () => {
        setErrorMessage('');
    }

    return (
        <React.Fragment>
            <DragAndDropContainer
                onDrop={drop}
                onDragOver={dragover}
                onDragEnter={dragenter}>
                <input
                    type="file"
                    id="file-upload"
                    onChange={handleFiles}
                    multiple={true}
                    accept={acceptFileTypes}
                    style={{ display: "none" }}
                />
                <img src={UploadIcon} alt="upload"/>
                <br/>
                <label className="ServiceRequest_lbl_imgtext">Drop images here, or</label>
                <br/>
                <label className="ServiceRequest_btn_choosefile">
                        <input type="file" id="myfile" disabled={isDisabled} onChange={handleFiles}/>Choose File
                </label>
                <br/>
                <label className="ServiceRequest_lbl_notes">{hintText}</label>
            </DragAndDropContainer>
            <span hidden={errorMessage ? false : true}>
                <Icon name='exclamation triangle' style={{ 'color': '#D52B1E'}} />
                <label style={{ 'color': '#D52B1E', 'font-size': '12px', 'font-family': 'Arial', 'display': 'inline'}}>{errorMessage}</label>
            </span>
            <table style={{"margin-top":"13px", "width":"100%"}} id="ServiceRequestTable">
                <tbody>
                    {
                        uploadedFilesRows ? uploadedFilesRows.map((el, index) =>(
                            <tr key={index}>
                                <td width="30%" style={{"word-break": "break-all", fontFamily: 'Arial'}}><span style={{"font-weight":"bold"}}>{el.filename}</span></td>
                                <td width="50%" style={{fontFamily: 'Arial'}}>{el.filesize}</td>
                                <td width="20%" style={{fontFamily: 'Arial'}}>{el.date}</td>
                                <td style={isDisabled ? {'pointerEvents':'none'} : {}} onClick={() => onDelete(el.filename)}><img src={CloseIcon} alt="closeicon" className="Attachment_Delete_btn" /></td>
                            </tr>
                        ))
                        : ""
                    }
                </tbody>
            </table>
        </React.Fragment>
    )
}

export default DragAndDropFileUpload;